"use client";

import { Button } from "@/components/ui/button";
import { Card, CardContent, CardFooter, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function NosServices() {
  const {
    ref: ref1,
    isVisible: isVisible1
  } = useRevealOnScroll({
    threshold: 0.2
  });
  const {
    ref: ref2,
    isVisible: isVisible2
  } = useRevealOnScroll({
    threshold: 0.2
  });
  const {
    ref: ref3,
    isVisible: isVisible3
  } = useRevealOnScroll({
    threshold: 0.2
  });
  const {
    ref: ref4,
    isVisible: isVisible4
  } = useRevealOnScroll({
    threshold: 0.2
  });
  const services = [{
    id: 1,
    icon: "/img/videography_events_icon.png",
    title: "Vidéographie événements",
    description: "Mariages, conférences, spectacles – nous capturons chaque moment avec créativité et professionnalisme.",
    cta: "Nous contacter pour ce service"
  }, {
    id: 2,
    icon: "/img/professional_photography_icon.png",
    title: "Photographie professionnelle",
    description: "Portraits, corporatif, produits – des images qui racontent votre histoire avec authenticité.",
    cta: "Nous contacter pour ce service"
  }, {
    id: 3,
    icon: "/img/brand_promotion_icon.png",
    title: "Promotion image de marque",
    description: "Vidéos publicitaires et contenus pour réseaux sociaux qui amplifient votre présence en ligne.",
    cta: "Nous contacter pour ce service"
  }, {
    id: 4,
    icon: "/img/dj_photography_icon.png",
    title: "Services DJ + photographie",
    description: "Animation musicale et captation photo pour des événements inoubliables et dynamiques.",
    cta: "Nous contacter pour ce service"
  }];
  const refs = [ref1, ref2, ref3, ref4];
  const visibilities = [isVisible1, isVisible2, isVisible3, isVisible4];
  return <section className="bg-light-background py-16 px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-4xl sm:text-5xl font-display font-bold text-primary mb-4">
            Nos services
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            Découvrez nos quatre catégories de services professionnels conçus pour sublimer vos moments et votre marque.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {services.map((service, i) => <div key={service.id} ref={refs[i]} data-index={i} className={`transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] ${visibilities[i] ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`} style={{
          transitionDelay: `${i * 100}ms`
        }}>
              <Card className="h-full bg-gradient-to-br from-secondary-light to-background shadow-soft hover:shadow-medium hover:-translate-y-1 transition-all duration-[var(--duration-medium)] ease-[var(--ease-out-back)] border border-border/50">
                <CardHeader className="flex flex-col items-center text-center pt-8">
                  <div className="mb-4 w-20 h-20 flex items-center justify-center rounded-full bg-primary/10">
                    <img src={service.icon} alt={service.title} className="w-12 h-12 object-contain" />
                  </div>
                  <CardTitle className="text-2xl font-display font-bold text-primary mb-2">
                    {service.title}
                  </CardTitle>
                  <CardDescription className="text-base text-muted-foreground leading-relaxed">
                    {service.description}
                  </CardDescription>
                </CardHeader>
                <CardFooter className="flex justify-center pb-8">
                  <Link to="/ContactPage">
                    <Button variant="default" size="lg" className="w-full bg-primary text-foreground-primary hover:bg-primary-hover hover:scale-[1.03] active:bg-primary-active transition-all duration-[var(--duration-medium)] ease-[var(--ease-spring)] shadow-xs hover:shadow-medium">
                      {service.cta}
                    </Button>
                  </Link>
                </CardFooter>
              </Card>
            </div>)}
        </div>
      </div>

      <div className="bg-dark-background py-8 mt-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <p className="text-foreground-dark text-sm">
            Chaque service est conçu pour capturer l'essence de vos moments et amplifier votre présence visuelle.
          </p>
        </div>
      </div>
    </section>;
}